import { axiosInstance } from "./axiosInstance";

export const CoursesService = {
    getAll: async (filter) => {
        return await axiosInstance.get('/api/feature/membership/courses', { params: filter });
    },
    create: async (data) => {
        return await axiosInstance.post('/api/feature/membership/courses', data);
    },
    update: async (id, data) => {
        return await axiosInstance.post(`/api/feature/membership/courses/update/${id}`, data);
    },
    delete: async (id) => {
        return await axiosInstance.delete(`/api/feature/membership/courses/delete/${id}`);
    },
    attachDetach: async (id, data) => {
        return await axiosInstance.post(`/api/feature/membership/courses/attach-detach/${id}`, data);
    },
}